// extracted by mini-css-extract-plugin
export var cardIcon = "_9r-4";
export var checkboxCard = "_9r-0";
export var checkboxCardSelected = "_9r-1";
export var disabled = "_9r-2";
export var outerBorder = "_9r-3";
export var spacerMedium = "_9r-7";
export var spacerSmall = "_9r-6";
export var spacerXsmall = "_9r-5";